import { AiTaggingStep, AiTaggingType, AiThreshold, AiThresholdMarks, DataScopeField, SmartLabelStatus, AiModel, } from './enums';
export const THRESHOLD_MARKS_MAP = {
    0: AiThresholdMarks.LOW,
    50: AiThresholdMarks.MEDIUM,
    100: AiThresholdMarks.HIGH,
};
export const DEFAULT_FIELD_DETAIL = {
    currentField: null,
    selectedNodeList: null,
    taggingType: AiTaggingType.SINGLE,
    threshold: AiThreshold.MEDIUM,
};
export const LOADING_STEP_MAP = {
    [SmartLabelStatus.IN_PREPARE_DATA]: [SmartLabelStatus.IN_PREPARE_DATA],
    [SmartLabelStatus.READY_PREPARE_DATA]: [SmartLabelStatus.IN_PREPARE_DATA],
    [SmartLabelStatus.IN_TRAINING]: [SmartLabelStatus.IN_TRAINING],
    [SmartLabelStatus.READY_TO_LABEL]: [SmartLabelStatus.IN_LABEL],
    [SmartLabelStatus.IN_LABEL]: [SmartLabelStatus.IN_LABEL],
    [SmartLabelStatus.FINISH_LABEL]: [SmartLabelStatus.IN_LABEL],
};
/**
 * AI 标引pro版的步骤
 */
export const AI_TAGGING_STEPS = [
    AiTaggingStep.SELECT_FIELD,
    AiTaggingStep.FIELD_DETAIL,
    AiTaggingStep.TAGGING_PROCESS,
    AiTaggingStep.TAGGING_RESULT,
];
/**
 * AI 标引max版的步骤
 */
export const AI_TAGGING_MAX_STEPS = [
    AiTaggingStep.SELECT_FIELD,
    AiTaggingStep.FIELD_DETAIL,
    AiTaggingStep.NODE_PARSING,
    AiTaggingStep.TAGGING_SETTING,
    AiTaggingStep.TAGGING_PROCESS,
    AiTaggingStep.TAGGING_RESULT,
];
export const PROCESSING_STEP_MAP = [
    AiTaggingStep.NODE_PARSING,
    AiTaggingStep.TAGGING_PROCESS,
];
export const DATA_SCOPE_OPTIONS = [
    DataScopeField.TTL,
    DataScopeField.TECHNICAL_TITLE,
    DataScopeField.ABST,
    DataScopeField.CLMS,
    DataScopeField.DESC,
    DataScopeField.TECHNICAL_PROBLEM,
    DataScopeField.PATENT_INNO_SUMMARY,
    DataScopeField.EFFICIENCY_SENTENCE,
];
export const DEFAULT_DATA_SCOPE = [
    DataScopeField.TTL,
    DataScopeField.TECHNICAL_TITLE,
    DataScopeField.ABST,
    DataScopeField.CLMS,
    DataScopeField.DESC,
    DataScopeField.TECHNICAL_PROBLEM,
    DataScopeField.PATENT_INNO_SUMMARY,
    DataScopeField.EFFICIENCY_SENTENCE,
];
export const DISABLED_SCOPE_OPTIONS = [
    DataScopeField.ABST,
];
export const DEFAULT_TAGGING_SETTING = {
    taggingType: AiTaggingType.SINGLE,
    threshold: 50,
    dataScope: DEFAULT_DATA_SCOPE,
    aiModel: AiModel.PATSNAP_GPT_COMPLEX,
};
export const DEFAULT_NODE_SUMMARY = {
    context: '',
};
export const AI_MODEL_LIMITS = {
    [AiModel.PATSNAP_ML]: 50000,
    [AiModel.PATSNAP_GPT]: 5000,
    [AiModel.PATSNAP_GPT_COMPLEX]: 5000,
};
